import script from "./BaseRadio.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseRadio.vue?vue&type=script&setup=true&lang=ts"

import "./BaseRadio.vue?vue&type=style&index=0&id=24727bdc&lang=scss"

const __exports__ = script;

export default __exports__